import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import Dropdown from "../../common/components/dropdown";
import Pagination from "../../common/components/pagination";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { useNavigate, useLocation } from "react-router-dom";
import ClickOutside from "../../common/components/clickOutside";
import Utils from "../../utility";
import { IoMdArrowUp, IoMdArrowDown } from "react-icons/io";

const RepairList = ({
  list,
  totalPages,
  currentPage,
  handlePageChange,
  handleFirstPage,
  handleLastPage,
  loading,
  setDebouncedSearch,
  setResultFilter,
  resultFilter,
  stp,
  setSTP,
  setFilterBy,
  modifiedDate,
  setDate,
  selectTime,
  setSelectTime,
  setProcessedDate,
  selectModifiedTime,
  createdOnSortBy,
  setCreatedOnSortBy,
  date,
  topRef,
  setCurrentPage,
  processedDate,
  setModifiedDate,
  setSelectModifiedTime,
  selectProcessedTime,
  setSelectProcessedTime,
  withinSLA,
  setWithinSLA,
  sort,
  setSort,
  debounce
}) => {
  const [open, setOpen] = useState(false);
  const [openProcessed, setOpenProcessed] = useState(false);
  const [openModified, setOpenModified] = useState(false);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const [searchClaim, setSearchClaim] = useState("");
  const [hover, setHover] = useState("");
  const [selectedRow, setSelectedRow] = useState(
    Number(sessionStorage.getItem("selectedRow")) || null
  );
  const [range, setRange] = useState({
    startDate: date?.startDate ? new Date(date?.startDate) : null,
    endDate: date?.endDate ? new Date(date?.endDate) : new Date(""),
    key: "selection"
  });

  const [rangeModified, setRangeModied] = useState({
    startDate: date?.startDate ? new Date(date?.startDate) : null,
    endDate: date?.endDate ? new Date(date?.endDate) : new Date(""),
    key: "selection"
  });

  const [rangeProcessed, setRangeProcessed] = useState({
    startDate: processedDate?.startDate
      ? new Date(processedDate?.startDate)
      : null,
    endDate: processedDate?.endDate
      ? new Date(processedDate?.endDate)
      : new Date(""),
    key: "selection"
  });

  const isWithoutFeedback =
    queryParams.get("questionText") ||
    queryParams.get("reportFeedback") ||
    queryParams.get("feedbackType") ||
    queryParams.get("report") ||
    queryParams.get("slaCompliance") ||
    queryParams.get("processedWithinSLA");
  const details = queryParams.get("details");

  const navigate = useNavigate();
  const handleDateSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    const formattedStartDate = Utils.formatDateYear(startDate);
    const formattedEndDate = Utils.formatDateYear(endDate);

    setRange({
      ...range,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    });

    setDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
    setFilterBy("createdDate");
    setCurrentPage(1);
  };

  const handleDateSelectProcessed = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    const formattedStartDate = Utils.formatDateYear(startDate);
    const formattedEndDate = Utils.formatDateYear(endDate);

    setRangeProcessed({
      ...rangeProcessed,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    });

    setProcessedDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
    setFilterBy("processedDate");
    setCurrentPage(1);
  };

  const handleModifiedDate = (ranges) => {
    const { startDate, endDate } = ranges.selection;

    const formattedStartDate = Utils.formatDateYear(startDate);
    const formattedEndDate = Utils.formatDateYear(endDate);

    setRangeModied({
      ...range,
      startDate: ranges.selection.startDate,
      endDate: ranges.selection.endDate
    });

    setModifiedDate((prev) => ({
      ...prev,
      startDate: formattedStartDate,
      endDate: formattedEndDate
    }));
    setFilterBy("modifiedDate");
    setCurrentPage(1);
  };

  const handleSelectProcessed = (value) => {
    setSelectProcessedTime(value);
    if (value === "Custom") {
      setOpenProcessed(true);
    } else {
      setOpenProcessed(false);
    }
  };

  const handleSelect = (value) => {
    setSelectTime(value);
    if (value === "Custom") {
      setOpen(true);
    } else {
      setOpen(false);
    }
  };

  const handleModifiedSelect = (value) => {
    setSelectModifiedTime(value);
    if (value === "Custom") {
      setOpenModified(true);
    } else {
      setOpenModified(false);
    }
  };

  const handleCreatedSort = (type) => {
    setCreatedOnSortBy((prevOrder) => (prevOrder === "asc" ? "desc" : "asc"));
    setSort(type);
  };

  const handleSearch = (e) => {
    const value = e.target.value ?? "";
    setSearchClaim(value);

    const searchIsEmpty = value.trim() === "";
    setSelectProcessedTime(searchIsEmpty ? "Last 14 days" : "All");
  };
  const handleClearFilters = () => {
    setSelectTime("All");
    setSearchClaim("");
    setDebouncedSearch("");
    setRange({
      startDate: new Date(),
      endDate: new Date(),
      key: "selection"
    });
    setSelectProcessedTime("Last 14 days");
    setFilterBy("processedDate");
    setSelectModifiedTime("All");
    setCurrentPage(1);
  };

  useEffect(() => {
    if (isWithoutFeedback || details) {
      setSelectProcessedTime(selectProcessedTime);
    }
    if (searchClaim !== "") {
      const handler = setTimeout(() => {
        setDebouncedSearch(searchClaim);
        setCurrentPage(1);
      }, 600);

      return () => clearTimeout(handler);
    } else {
      setDebouncedSearch("");
    }

    // eslint-disable-next-line
  }, [searchClaim]);

  useEffect(() => {
    if (debounce) setSearchClaim(debounce);
  }, []);

  const userTZ = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return (
    <div className="h-full">
      <div className="flex  flex-wrap justify-between">
        <div className="flex flex-wrap items-center gap-2 pl-2.5">
          <img
            onClick={() => {
              if (isWithoutFeedback && !details) {
                navigate(-1);
              } else {
                navigate("/inspection-claims");
              }
            }}
            src="/images/left-arrow.svg"
            alt=""
            className="cursor-pointer"
          />

          <span className="font-InterBold text-ft25-30 text-black-10">
            Claims
          </span>
          <div className="ml-3 flex h-10 w-55 items-center gap-2 rounded-lg border  border-grey-10 bg-white p-3">
            <img
              src="/images/search-safe-guard.svg"
              alt="searchIcon"
              className="size-5 opacity-60"
            />
            <input
              type="text"
              placeholder="Claim Search"
              value={searchClaim}
              onChange={handleSearch}
              className="w-full bg-transparent font-InterRegular text-ft14-17 text-black-0 placeholder:text-grey-20 focus:outline-none"
            />
          </div>
          <ClickOutside isOpen={open} onClickOutside={() => setOpen(false)}>
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Date"}
                value={selectTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelect}
                setOpenCalendar={setOpen}
                startDate={date?.startDate}
                endDate={date?.endDate}
              />
              {open && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[range]}
                    onChange={handleDateSelect}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>

          <ClickOutside
            isOpen={openProcessed}
            onClickOutside={() => setOpenProcessed(false)}
          >
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Processed"}
                value={selectProcessedTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleSelectProcessed}
                setOpenCalendar={setOpenProcessed}
                startDate={processedDate?.startDate}
                endDate={processedDate?.endDate}
              />
              {openProcessed && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[rangeProcessed]}
                    onChange={handleDateSelectProcessed}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>

          <ClickOutside
            isOpen={openModified}
            onClickOutside={() => setOpenModified(false)}
          >
            <div className="relative">
              <Dropdown
                width={"min-w-30"}
                text={"Modified"}
                value={selectModifiedTime}
                list={["All", "Last 14 days", "Previous month", "Custom"]}
                handleSelect={handleModifiedSelect}
                setOpenCalendar={setOpenModified}
                startDate={modifiedDate?.startDate}
                endDate={modifiedDate?.endDate}
              />
              {openModified && (
                <div className="absolute z-[999]">
                  <DateRange
                    ranges={[rangeModified]}
                    onChange={handleModifiedDate}
                    className="rounded-md border border-grey-30"
                    showDateDisplay={false}
                    showMonthAndYearPickers={false}
                  />
                </div>
              )}
            </div>
          </ClickOutside>

          <Dropdown
            width={"w-31"}
            text={"Claim Status"}
            value={resultFilter}
            list={["All", "Open", "InProgress", "Approved", "Failed"]}
            handleSelect={setResultFilter}
            setCurrentPage={setCurrentPage}
          />

          <Dropdown
            width={"w-31"}
            text={"STP / ECE Queue"}
            value={stp}
            list={["All", "STP", "ECE"]}
            handleSelect={setSTP}
            setCurrentPage={setCurrentPage}
          />

          <Dropdown
            width={"w-31"}
            text={"Within SLA"}
            value={withinSLA}
            list={["All", "Yes", "No"]}
            handleSelect={setWithinSLA}
            setCurrentPage={setCurrentPage}
          />

          <div
            className="flex cursor-pointer items-center gap-1"
            onClick={handleClearFilters}
          >
            <span className="font-InterRegular text-ft14-17 text-blue-10">
              Clear
            </span>
            <img src="/images/clear.svg" alt="" />
          </div>
          <div className="ml-10 flex gap-3">
            {!isWithoutFeedback && (
              <div
                onClick={() => navigate("/inspection-claims/report")}
                className="flex h-10 cursor-pointer items-center justify-center rounded-lg border border-grey-10 p-3"
              >
                <span className="font-InterRegular text-ft14-17 ">
                  Show Inspection Report
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex h-80vh items-center justify-center">
          <div className="loader "></div>
        </div>
      ) : list?.length > 0 ? (
        <div>
          <div
            ref={topRef}
            className=" mt-10 max-h-75vh w-full  overflow-y-auto"
          >
            <table className="w-full">
              <thead>
                <tr className="sticky top-0  z-10 w-full bg-white font-InterBold text-ft10-18.15 text-black-10">
                  <td className="pb-2.5 pl-2.5">Claim Number</td>

                  {/* <td>Contract Number</td> */}
                  <td>
                    <div
                      className="flex cursor-pointer gap-1"
                      onClick={() => handleCreatedSort("createdOn")}
                      onMouseEnter={() => setHover("createdOn")}
                      onMouseLeave={() => setHover("")}
                    >
                      <span className="font-InterBold text-ft10-18.15  text-black-10">
                        Created On
                      </span>
                      {createdOnSortBy === "asc" && sort === "createdOn" ? (
                        <IoMdArrowDown />
                      ) : (
                        sort === "createdOn" && <IoMdArrowUp />
                      )}
                      {hover === "createdOn" &&
                        createdOnSortBy !== "asc" &&
                        sort !== "createdOn" && <IoMdArrowDown />}
                    </div>
                  </td>

                  <td>
                    <div
                      className="flex cursor-pointer gap-1"
                      onClick={() => handleCreatedSort("processedOn")}
                      onMouseEnter={() => setHover("processedOn")}
                      onMouseLeave={() => setHover("")}
                    >
                      <span className="font-InterBold text-ft10-18.15  text-black-10">
                        Processed On
                      </span>
                      {createdOnSortBy === "asc" && sort === "processedOn" ? (
                        <IoMdArrowDown />
                      ) : (
                        sort === "processedOn" && <IoMdArrowUp />
                      )}
                      {hover === "processedOn" &&
                        createdOnSortBy !== "asc" &&
                        sort !== "processedOn" && <IoMdArrowDown />}
                    </div>
                  </td>
                  <td>
                    <div
                      className="flex cursor-pointer gap-1"
                      onClick={() => handleCreatedSort("modifiedOn")}
                      onMouseEnter={() => setHover("modifiedOn")}
                      onMouseLeave={() => setHover("")}
                    >
                      <span className="font-InterBold text-ft10-18.15  text-black-10">
                        Modified On
                      </span>
                      {createdOnSortBy === "asc" && sort === "modifiedOn" ? (
                        <IoMdArrowDown />
                      ) : (
                        sort === "modifiedOn" && <IoMdArrowUp />
                      )}
                      {hover === "modifiedOn" &&
                        createdOnSortBy !== "asc" &&
                        sort !== "modifiedOn" && <IoMdArrowDown />}
                    </div>
                  </td>

                  <td>Within SLA</td>
                  <td>Actual - Expected Time </td>
                  <td>Claim Status</td>

                  <td>STP / ECE Queue</td>
                  {/* <td>Decision Status</td> */}
                </tr>
              </thead>
              <tbody>
                {list.map((item, idx) => {
                  return (
                    <tr
                      onClick={() => {
                        setSelectedRow(idx);
                        sessionStorage.setItem("selectedRow", idx);

                        sessionStorage.setItem(
                          "scrollPosition",
                          topRef.current.scrollTop
                        );

                        navigate({
                          pathname: `/inspection-claims/${item?.claimNumber}`,
                          search: search
                        });
                      }}
                      key={idx}
                      className={`cursor-pointer border-t border-grey-30  ${idx === selectedRow ? "bg-grey-10 bg-opacity-[.2]" : "hover:bg-grey-10 hover:bg-opacity-[.2]"}`}
                    >
                      <td className="w-10per py-3.5 pl-2.5 font-InterRegular text-ft10-18.15 text-black-10">
                        {item.claimNumber}
                      </td>

                      <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                        {item.claimCreatedDate
                          ? moment
                              .tz(item.claimCreatedDate, "America/New_York")
                              .tz(userTZ)
                              .format("DD MMM YYYY h:mm A")
                          : "-"}
                      </td>
                      <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                        {item.processedOn
                          ? moment
                              .tz(item.processedOn, "America/New_York")
                              .tz(userTZ)
                              .format("DD MMM YYYY h:mm A")
                          : "-"}
                      </td>
                      <td className="w-15per font-InterRegular text-ft15-18 text-black-10">
                        {item.claimModifiedDate
                          ? moment
                              .tz(item.claimModifiedDate, "America/New_York")
                              .tz(userTZ)
                              .format("DD MMM YYYY h:mm A")
                          : "-"}
                      </td>

                      <td className="w-10per font-InterRegular text-ft15-18 text-black-10">
                        {item.actualTimeTakenSeconds
                          ? item.expectedRepairFirstSlaSeconds -
                              item?.actualTimeTakenSeconds >
                            0
                            ? "Yes"
                            : "No"
                          : "-"}
                      </td>

                      <td className="w-10per font-InterRegular text-ft15-18 text-black-10">
                        {`${item?.actualTimeTakenSeconds || 0}s -
                        ${item?.expectedRepairFirstSlaSeconds || 0}s `}
                      </td>

                      <td className="w-10per">
                        {item?.claimStatus && (
                          <div
                            className={`${
                              item.claimStatus.toLowerCase() === "approved"
                                ? " bg-green-10 bg-opacity-[.2] text-green-10"
                                : item.claimStatus?.toLowerCase() === "failed"
                                  ? "bg-red-20 text-red-10"
                                  : "bg-grey-100 bg-opacity-[.5] text-black-20 text-opacity-[.8]"
                            } w-max rounded-full  px-2.5 py-1 font-InterMedium text-ft14-17 `}
                          >
                            {Utils.formatText(item.claimStatus)}
                          </div>
                        )}
                      </td>

                      <td className="w-10per font-InterRegular text-ft15-18 text-black-10">
                        {item?.isEceQueue ? "ECE Queue" : "STP"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            handleFirstPage={handleFirstPage}
            handleLastPage={handleLastPage}
            handlePageChange={handlePageChange}
          />
        </div>
      ) : (
        <div className="flex h-80 items-center justify-center">
          <span className="font-InterBold text-ft24-32 text-black-0">
            No data found
          </span>
        </div>
      )}
    </div>
  );
};

export default RepairList;
